module.exports = __webpack_public_path__ + "media/images/payment/visa-mastercard-7046de8e909430169af83a74c0586620.svg";